<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="form-group text-left">
          <router-link to="/crMealTag">
            <div class="btn btn-default btn-table-title">新增餐點種類</div>
          </router-link>
        </div>
        <div class="form-group">
          <select class="form-control h-38" v-model="selectActive">
            <option value="99">全部</option>
            <option value="1">顯示</option>
            <option value="0">隱藏</option>
          </select>
        </div>
      </div>
      <div class="col-sm-6 text-right">
        <div class="form-group">
          <select class="form-control h-38">
            <option value="1">名稱</option>
          </select>
        </div>
        <div class="form-group search-bar">
          <div class="input-group">
            <input class="form-control" type="text" v-model="searchInput">
            <span class="input-group-addon c-pointer" @click="getmealTagList()"><i class="fa fa-search"></i></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">圖示</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">名稱 (ID)</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">底圖</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">顯示</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">排序</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
            <!-- col different-->
          </tr>
          </thead>
          <tbody>
          <tr class="even" role="row" v-for="(mealTag, index) in mealTagList">
            <!-- cloumn 0 -->
            <td class="sorting_1">{{index + 1}}</td>
            <!-- column 1-->
            <td>
              <object style="width: 33px;" type="image/svg+xml" :data="mealTag.icon"></object>
            </td>
            <!-- column 2-->
            <td>
              <span>{{mealTag.name}} ({{mealTag.tag_id}})</span>
            </td>
            <!-- column 3-->
            <td><img class="img-ad-table" :src="mealTag.image"></td>
            <!-- column 4-->
            <td>
              <span v-if="mealTag.is_visible" class="label label-success">顯示</span>
              <span v-if="!mealTag.is_visible"  class="label label-danger">隱藏</span>
            </td>
            <td>{{mealTag.sort}}</td>
            <!--<td>{{ad.create_time}}</td>-->
            <!-- column last-->
            <td>
              <router-link :to="{path: '/upMealTag/' + mealTag.tag_id}">
                <button class="btn btn-default"><i class="fa fa-pencil" aria-hidden="true"></i></button>
              </router-link>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                :groupAmount="groupAmount" :clickPage="clickPage"
      >
      </paginate>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default{
  data () {
    return {
      selectActive: 99,
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      mealTagList: [],
      searchInput: ''
    }
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getmealTagList()
    },
    getmealTagList () {
      var self = this
      var data = {
        page: this.tableIndex,
        size: this.count
      }
      var url = '/mealTag/list?page=' + data.page + '&size=' + data.size
      if (parseInt(this.selectActive, 10) !== 99) url = url + '&is_visible=' + this.selectActive
      if (this.searchInput.trim()) url = url + '&name=' + this.searchInput
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.mealTagList = response.data.list
          self.total = response.data.list_total
        }
      })
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    }
  },
  created () {
    this.getmealTagList(1)
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    selectActive () {
      this.tableIndex = 1
      this.searchInput = ''
      this.getmealTagList()
    }
  }
}
</script>



// WEBPACK FOOTER //
// MealTagTableTemp.vue?2e6c2b4e